import {fetch, rap} from '@/utils/common'
export const actions = {
  handleFetchRule ({commit}, ruleNames) {
    const url = rap({
      config: `/fep/wx/${ruleNames.id}/param/${ruleNames.name}`
    })
    fetch(url.config).then(res => {
      commit('FETCH_RULES', {
        rules: res.data.param
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/stores/rules/actions.js